import themePropTypes from 'core/utils/prop-types/theme';

import withTheme from 'core/hocs/withTheme';
import { Indent } from 'core/components/Wrappers';

function PageIndent(props) {
  const {
    theme: {
      layout: {
        indents,
      },
    },
    ...otherProps
  } = props;

  return (
    <Indent
      {...indents}
      {...otherProps}
    />
  );
}

PageIndent.propTypes = {
  /** @ignore */
  theme: themePropTypes(`{
    layout: {
      indents: {
        top,
        right,
        bottom,
        left,
      }
    },
  }`),
};

const PageIndentWithHOC = withTheme(PageIndent);
PageIndentWithHOC.displayName = 'PageIndent';

export default PageIndentWithHOC;
